import { css } from "@styled-system/css";

export const headerClass = css({
	display: "flex",
	justifyContent: "space-between",
	gap: "8",
});
